import { atomWithReset } from 'jotai/utils';

import {
  FinishConfirmModalState,
  MedicationFollowupModal,
  NotificationConfirmModalState,
  NotificationCongestionModalState,
  ProfileDrawerState,
} from './types';

export const profileDrawerState = atomWithReset<ProfileDrawerState>({
  isOpen: false,
  error: null,
  patientId: null,
  appointmentId: null,
});

export const notificationConfirmModalState = atomWithReset<NotificationConfirmModalState>({
  isOpen: false,
  appointmentId: null,
  patientId: null,
  immediate: false,
});

export const notificationCongestionModalState = atomWithReset<NotificationCongestionModalState>({
  isOpen: false,
  appointmentId: null,
  patientId: null,
});

export const finishConfirmModalState = atomWithReset<FinishConfirmModalState>({
  isOpen: false,
  encounterId: null,
  patientId: null,
  error: null,
});

export const medicationFollowupModalState = atomWithReset<MedicationFollowupModal>({
  isOpen: false,
  appointmentId: null,
});
